import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { Leaf, Shield, Users, CheckCircle, Recycle } from "lucide-react";

const ValuesSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const values = [
    {
      icon: Leaf,
      title: "Engagement environnemental",
      description: "Nous privilégions les matières recyclables et issues de sources durables pour minimiser notre impact écologique.",
    },
    {
      icon: Shield,
      title: "Qualité & Sécurité alimentaire",
      description: "Tous nos produits respectent les normes européennes strictes pour le contact alimentaire.",
    },
    {
      icon: Users,
      title: "Service client",
      description: "Une équipe dédiée pour vous accompagner dans le choix de vos solutions d'emballage.",
    },
    {
      icon: CheckCircle,
      title: "Contrôle qualité strict",
      description: "Contrôles rigoureux à chaque étape par un organisme certificateur indépendant.",
    },
    {
      icon: Recycle,
      title: "Durabilité",
      description: "Des emballages conçus pour être recyclés et réintégrés dans le cycle de production.",
    },
  ];

  return (
    <section className="py-24 bg-background relative" ref={ref}>
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="inline-block text-sm font-medium text-primary uppercase tracking-wider mb-4"
          >
            Nos engagements
          </motion.span>

          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-display text-3xl md:text-4xl font-bold text-accent mb-6"
          >
            Nos Valeurs
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-muted-foreground"
          >
            Chez AMS DISTRIB, nous plaçons la qualité, la durabilité et le service 
            au cœur de notre mission.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map((value, index) => (
            <motion.div
              key={value.title}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.1 * index }}
              className="group relative p-8 rounded-2xl bg-card border border-border hover:border-primary/30 transition-all duration-500 hover-float"
            >
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <value.icon className="w-7 h-7 text-primary" />
              </div>
              
              <h3 className="font-display text-xl font-semibold text-foreground mb-3">
                {value.title}
              </h3>
              
              <p className="text-muted-foreground text-sm leading-relaxed">
                {value.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;